export default __webpack_public_path__ + "static/media/Pehli-kiran-school.56d51b7a.png";